import SlidewareBindings from './lib/bindings'

export { insertSlides, insertJoinInstructions, insertFlowSlides } from './lib/insert'
export { sync, syncAll } from './lib/sync'
export { login, logout } from './lib/auth'
export { updatePlaceholders } from './lib/placeholder_cache'
export { platform } from './lib/platform'
export { createSlideSet } from './lib/slideset'
export { activitiesToClear, clearResponses, getArchiveName } from './lib/clear_responses'
const bindings = new SlidewareBindings()
export { bindings }
